<app-note-translation
	[isEncounterNotes]="props['isEncounterNotes']"
	[preloadedText]="preloadedText"
	[preloadedLanguageSelectionCode]="preloadedLanguageCode"
	[notesFieldLabel]="props.label || 'Notes'"
	[maxCharLength]="props['maxCharLength'] || 8000"
	(notesChanged)="onNotesChanged($event)"
	(notesLanguageChanged)="onLanguageChanged($event)"
></app-note-translation>
